import { createRowActions, DataTable, type DataTableVariant } from "@msuite/ui/table";
import type React from "react";
import { transferCarriersTableColumns } from "@/components/stock";
import { useTransferCarriers } from "@/hooks/use-transfer-carriers";
import { RowActions } from "./row-actions";

/** Props Interface */
interface TransferCarriersTableProps {
	menu?: React.ReactNode;
	variant?: DataTableVariant;
}

export function TransferCarriersTable({
	menu = null,
	variant = "table",
}: TransferCarriersTableProps) {
	/** Hooks */
	const { transferCarriers, isLoading, queryKey, refetch } = useTransferCarriers();

	/** Render */
	return (
		<DataTable
			data={transferCarriers}
			columns={[...transferCarriersTableColumns, createRowActions(RowActions)]}
			isLoading={isLoading}
			refetch={refetch}
			queryKey={queryKey}
			menu={menu}
			persistenceKey="data-transfer-carriers-table"
			initialPinningState={{ start: [], end: ["openLegCount"] }}
			variant={variant}
		/>
	);
}
